import { render, staticRenderFns } from "./NewPermissionList.vue?vue&type=template&id=3a24a82a&scoped=true"
import script from "./NewPermissionList.vue?vue&type=script&lang=js"
export * from "./NewPermissionList.vue?vue&type=script&lang=js"
import style0 from "./NewPermissionList.vue?vue&type=style&index=0&id=3a24a82a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a24a82a",
  null
  
)

export default component.exports